import { useTranslation } from 'react-i18next';

/**
 * IriisLink - Wraps enemy names with an IRIIS external link when available.
 *
 * When `url` is provided: renders a green link that opens in a new tab,
 * with a small external-link icon on hover.
 *
 * When `url` is null/undefined: renders children as plain text.
 *
 * @param {Object} props
 * @param {string|null} props.url - IRIIS external URL (null = no link)
 * @param {React.ReactNode} props.children - Content to wrap
 * @param {string} [props.className] - Additional CSS classes
 */
const IriisLink = ({ url, children, className = '' }) => {
  const { t } = useTranslation();

  if (!url) {
    return <span className={className}>{children}</span>;
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={t('common|iriis.view_on_iriis')}
      className={`iriis-link iriis-reveal ${className}`}
    >
      {children}
      <svg
        className="iriis-link-icon"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M10.5 1.5L5.25 6.75M10.5 1.5H7.5M10.5 1.5V4.5M4.5 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V7.5"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
};

export default IriisLink;
